import axios from "axios";
import Store from "../reduxStore/Store";
import { startLoading, stopLoading } from "../reduxStore/slices/progressSlice";
import { logout } from "../reduxStore/slices/authSlice";

const createAxiosInstance = (baseURL) => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  });

  let activeRequests = 0;

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      activeRequests++;
      Store.dispatch(startLoading());
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => {
      activeRequests--;
      if (activeRequests === 0) {
        Store.dispatch(stopLoading());
      }
      return response.data;
    },
    (error) => {
      activeRequests--;
      if (activeRequests === 0) {
        Store.dispatch(stopLoading());
      }

      if (error.code === "ERR_NETWORK") {
        console.error("No internet connection.");
        return Promise.reject(error);
      }

      const status = error.response?.status || 500;
      switch (status) {
        case 401:
          Store.dispatch(logout());
          break;
        case 403:
        case 404:
        default:
          break;
      }

      if (error.response && error.response.data) {
        return Promise.reject(error.response.data);
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export { createAxiosInstance };
